import React from 'react';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import translationsJson from 'data/translations.json';
import municipalitiesJson from "data/municipality.json";
import { Municipality, Municipalities } from 'lib/Types';

const translations: Translations = translationsJson;
const municipalities: Municipalities = municipalitiesJson;

interface MunicipalityItem {
    id: string;
    name: {
        [keyLang: string]: string;
    };
}

interface Props {
    value: string;
    onUpdate(municipality: string): void;
}

class MunicipalityFilter extends React.Component<Props, { currentValue: string }> {
    private municipalityList: MunicipalityItem[];

    constructor(props: Props) {
        super(props);
        this.state = {
            currentValue: this.props.value,
        }

        this.municipalityList = [];
        for (let id in municipalities) {
            this.municipalityList.push({
                id: id,
                name: municipalities[id].name
            });
        }
        this.municipalityList.sort((a, b) => a.name[window.lang].localeCompare(b.name[window.lang]));

        this.onChange = this.onChange.bind(this);
    }

    private onChange(event: SelectChangeEvent<unknown>, _: React.ReactNode) {
        const municipality = String(event.target.value);

        this.setState({ currentValue: municipality });
        this.props.onUpdate(municipality);
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.value !== this.props.value && this.props.value !== this.state.currentValue) {
            this.setState({ currentValue: this.props.value });
        }
    }

    render() {
        const optionList = [];
        for (const [i, mun] of this.municipalityList.entries()) {
            optionList.push(<MenuItem key={`mun-${i}`} value={mun.id}>{mun.name[window.lang]}</MenuItem>);
        }

        return (
            <FormControl className="dropdown">
                <InputLabel id="dropdown-label">{translations.municipality[window.lang]}</InputLabel>
                <Select labelId="dropdown-label" id="dropdown-select" onChange={this.onChange} value={this.state.currentValue} label={translations.gender[window.lang]}>
                    {optionList}
                </Select>
            </FormControl>
        );
    }
}

export default MunicipalityFilter;